import { ReferenceDataDetails } from "../types/referenceDataTypes";

export const referenceDataInitialValues: ReferenceDataDetails = {
  domain: "",
  id: "",
  name: "",
  index: "",
  isActive: true,
};
